import { render, staticRenderFns } from "./TableForm4.vue?vue&type=template&id=617fb5cb&scoped=true"
import script from "./TableForm4.vue?vue&type=script&lang=ts"
export * from "./TableForm4.vue?vue&type=script&lang=ts"
import style0 from "./TableForm4.vue?vue&type=style&index=0&id=617fb5cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617fb5cb",
  null
  
)

export default component.exports